var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsPlatformIconSwitch = function SvgNewcsPlatformIconSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_platform_icon_switch_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M842 572h18v18h-18z",
    "data-name": "\\u77E9\\u5F62 211",
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_platform_icon_switch_svg__a)",
    transform: "translate(-842 -572)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M852.26 588c-.067 0-.11-.044-.1-.1v-13.8a.087.087 0 0 1 .089-.089h2.166A3.586 3.586 0 0 1 858 577.6v6.818a3.585 3.585 0 0 1-3.585 3.582Zm2.661-7.72a1.419 1.419 0 1 0 1.419 1.42 1.42 1.42 0 0 0-1.419-1.42m-8.744-2.08a1.32 1.32 0 1 1 1.323 1.32 1.323 1.323 0 0 1-1.323-1.32m4.465-4.2c.066 0 .11.045.1.1v13.792a.1.1 0 0 1-.1.1h-3.057A3.585 3.585 0 0 1 844 584.4v-6.814a3.586 3.586 0 0 1 3.585-3.586zm-1.023 12.868v-11.746h-2.033a2.45 2.45 0 0 0-1.738.726 2.4 2.4 0 0 0-.726 1.738v6.814a2.45 2.45 0 0 0 .726 1.738 2.4 2.4 0 0 0 1.738.726h2.033Z",
    "data-name": "\\u8DEF\\u5F84 479"
  }))));
};
export default SvgNewcsPlatformIconSwitch;